import { z } from 'zod';
import { defineEndpoint } from '../define';
import {
  PollDetailSchema,
  PollFieldInputSchema,
  PollResultsVisibilitySchema,
  PollSlugSchema,
} from './shapes';

export const UpdatePollBodySchema = z
  .object({
    title: z.string().trim().min(1).max(300).optional(),
    slug: PollSlugSchema.optional(),
    description: z.string().trim().max(20_000).optional(),
    allowEdit: z.boolean().optional(),
    resultsVisibility: PollResultsVisibilitySchema.optional(),
    closesAt: z.string().datetime().nullable().optional(),
    reopen: z.boolean().optional(),
    fields: z.array(PollFieldInputSchema).max(200).optional(),
  })
  .refine((body) => !body.reopen || body.closesAt !== undefined, {
    message: 'Supply a deadline or null when reopening a poll',
    path: ['closesAt'],
  })
  .refine(
    (body) => Object.values(body).some((value) => value !== undefined),
    'No changes supplied',
  );
export type UpdatePollBody = z.input<typeof UpdatePollBodySchema>;

export const updatePoll = defineEndpoint({
  method: 'PATCH',
  path: '/v1/polls/:pollId',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: UpdatePollBodySchema,
  response: z.object({ data: PollDetailSchema }),
});
